import React, { Component } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { addOneBreadcrumbPath, keepSecondNavBreadcrumb } from '@/reducers/home/actions';
import TypeTableBox from './components/TypeTableBox';
import TypeEdit from './modal/TypeEdit';
import model from '@/reducers/system/operatingrule/model';

class EvaluationType extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,//路由对象
        addOneBreadcrumbPath: PropTypes.func, // 新增3级面包屑导航信息
        keepSecondNavBreadcrumb: PropTypes.func, // 保持2级面包屑导航信息

        evaluateTypes: PropTypes.array,
        getEvaluateTypes: PropTypes.func,//评价星级列表action

    }

    state = {
        renderModal: 'default',
        modalParams: {}
    }

    componentDidMount() {
        this.props.keepSecondNavBreadcrumb();
    }

    // 查询触发
    onSearch = (useCache) => {
        const { pageNum, pageSize } = this.state;
        this.searchCache = {
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getEvaluateTypes(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }


    //表格操作
    onTableOperate = (id, record) => {
        this.setState({ renderModal: 'editType', modalParams: record });
    }

    //关闭弹框
    onClose = (status) => {
        this.setState({ renderModal: 'default', modalParams: {} }, () => {
            status && this.onSearch('useCache');
        });
    }

    render() {
        const { evaluateTypes } = this.props;
        const { renderModal, modalParams } = this.state;
        const modalObject = {
            editType: <TypeEdit
                onClose={this.onClose}
                modalParams={modalParams} />,
            default: null
        };

        return <KeepAlive id='1' render={(state) => {
            if (!this.state.__aliveInit) {
                this.setState({ ...state, __aliveInit: true }, () => {
                    this.onSearch('useCache'); // 【第1步：调用查询接口初始化数据】
                });
            }
        }}>
            <div className={styles.flexBoxContainer}>
                <TypeTableBox
                    evaluateTypes={evaluateTypes}
                    onTableOperate={this.onTableOperate}
                />
                {modalObject[renderModal]}
            </div>
        </KeepAlive>;
    }
}

export default connect(state => ({
    evaluateTypes: state.operatingrule.evaluateTypes,
}), {
    addOneBreadcrumbPath,
    keepSecondNavBreadcrumb,
    ...model.actions
})(EvaluationType);